import styles from "../../../views/ReportView/ReportView.module.css";
import Swal from "sweetalert2";
import axios from "axios";

const AltaButtonCompany = ({ company, setCompany }) => {
  const handleAlta = async () => {
    const id = company.cuit;
    try {
      const res = await axios.post(process.env.REACT_APP_CASUALTY_COMPANY_API, {
        id,
        newStatus: "Alta",
      });

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: "La Persona Jurídica se dio de alta correctamente",
        });
        setCompany({
          ...company,
          status: "Alta",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message,
      });
    }
  };

  return (
    <button type="button" onClick={handleAlta} className={styles.altabaja}>
      Dar de Alta
    </button>
  );
};

export default AltaButtonCompany;